// BXYZ:..:eliot@bosmanxyz.xyz:..:.www.bosmanxyz.xyz

(() => {
  const rotAv = (nod) => nod.closest('[data-component="aterkallelse"]');

  const msFranToken = (namn, reserv) => {
    const v = getComputedStyle(document.documentElement).getPropertyValue(namn).trim();
    const n = parseFloat(v);
    if (Number.isNaN(n)) return reserv;
    if (v.endsWith('ms')) return n;
    if (v.endsWith('s')) return n * 1000;
    return reserv;
  };

  const falt = (rot, namn) => rot.querySelector(`[data-falt="${namn}"]`);

  const synkaRad = (el) => {
    const rad = el.closest('.aterkallelse__rad');
    if (!(rad instanceof HTMLElement)) return;
    const varde = 'value' in el ? String(el.value).trim() : '';
    rad.dataset.tillstand = varde ? 'fylld' : 'tom';
  };

  const kravFalt = (rot) => ['namn', 'epost', 'order'].map((namn) => falt(rot, namn));

  const validera = (rot) => {
    const fält = kravFalt(rot);
    let giltig = true;

    fält.forEach((el) => {
      if (!(el instanceof HTMLInputElement)) return;
      el.setCustomValidity('');
      if (!el.value.trim()) {
        el.setCustomValidity(rot.dataset.krav || 'This field is required.');
      }
      const ok = el.checkValidity();
      if (!ok) giltig = false;
      const rad = el.closest('.aterkallelse__rad');
      if (rad instanceof HTMLElement) {
        rad.dataset.tillstand = el.value.trim() ? 'fylld' : 'tom';
        if (!ok) rad.dataset.fel = 'ja';
        else delete rad.dataset.fel;
      }
    });

    const fel = rot.querySelector('[data-fel]');
    if (fel instanceof HTMLElement) fel.hidden = giltig;
    return giltig;
  };

  const rensaFel = (rot) => {
    const fält = kravFalt(rot);
    const redo = fält.every((el) => el instanceof HTMLInputElement && el.value.trim() && el.checkValidity());
    if (!redo) return;
    const fel = rot.querySelector('[data-fel]');
    if (fel instanceof HTMLElement) fel.hidden = true;
    fält.forEach((el) => {
      const rad = el.closest('.aterkallelse__rad');
      if (rad instanceof HTMLElement) delete rad.dataset.fel;
    });
  };

  const nollstall = (rot, form) => {
    if (form instanceof HTMLFormElement) form.reset();
    rot.querySelectorAll('.aterkallelse__rad[data-tillstand]').forEach((rad) => {
      if (rad.querySelector('.aterkallelse__falt')) rad.dataset.tillstand = 'tom';
    });
  };

  const visaSkickadSedanFormular = (rot, form) => {
    rot.dataset.tillstand = 'skickad';
    const budskap = rot.querySelector('.aterkallelse__skickad');
    if (budskap instanceof HTMLElement) budskap.focus();
    const svep = msFranToken('--rorelse-svep', 280);
    const reducerad = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const totalt = reducerad ? svep : svep * 10;
    window.setTimeout(() => {
      nollstall(rot, form);
      rot.dataset.tillstand = 'fyll';
    }, totalt);
  };

  const skrivKropp = (rot) => {
    const detaljer = falt(rot, 'detaljer') instanceof HTMLTextAreaElement
      ? falt(rot, 'detaljer').value.trim()
      : '';
    const rader = [
      'WITHDRAWAL NOTICE',
      `Name: ${falt(rot, 'namn').value.trim()}`,
      `Email: ${falt(rot, 'epost').value.trim()}`,
      `Order number: ${falt(rot, 'order').value.trim()}`,
    ];
    if (detaljer) rader.push(`Details: ${detaljer}`);
    falt(rot, 'kropp').value = rader.join('\n');
    const amne = falt(rot, 'amne');
    const order = falt(rot, 'order').value.trim();
    if (amne instanceof HTMLInputElement) {
      const bas = amne.getAttribute('value') || 'Withdrawal notice';
      amne.value = order ? `${bas} — ${order}` : bas;
    }
  };

  document.addEventListener('input', (handelse) => {
    const el = handelse.target;
    if (!(el instanceof HTMLInputElement) && !(el instanceof HTMLTextAreaElement)) return;
    const rot = rotAv(el);
    if (!rot) return;
    synkaRad(el);
    rensaFel(rot);
  });

  document.addEventListener('submit', (handelse) => {
    const form = handelse.target;
    if (!(form instanceof HTMLFormElement)) return;
    const rot = rotAv(form);
    if (!rot) return;
    if (!validera(rot)) {
      handelse.preventDefault();
      return;
    }
    skrivKropp(rot);
  });

  document.querySelectorAll('[data-component="aterkallelse"]').forEach((rot) => {
    if (!(rot instanceof HTMLElement)) return;
    const form = rot.closest('form');
    if (form instanceof HTMLFormElement) form.noValidate = true;
    if (rot.dataset.tillstand === 'skickad') visaSkickadSedanFormular(rot, form);
  });
})();
